import { Component, OnDestroy, OnInit } from "@angular/core";
import { LoaderService } from "../../../services/loader.service";
import { DrawerRef, DrawerService } from "mis-design-system/drawer";
import { Subject } from "rxjs";
import { take, takeUntil } from "rxjs/operators";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";
import { ConfigurationService } from "../../../services/configuration.service";
import { MealService } from "../meal.service";
import { MealOptionComponent } from "../meal-option/meal-option.component";

@Component({
  selector: "mis-employee-web-exp-meal-component",
  templateUrl: "./meal-component.component.html",
  styleUrls: ["./meal-component.component.scss"]
})
export class MealComponent implements OnInit, OnDestroy {
  Assets = CONSTANTS_ASSETS_EMP_WEB_EXP;
  show = false;
  mealData: NsEmpWebExpData.IMeal[] = [];
  selectedItem: NsEmpWebExpData.IMeal;
  selectedType: NsEmpWebExpData.IMealOption = {};
  mealStore: NsEmpWebExpData.IMeal[] = [];
  mealMapStore = new Map();
  private endObs = new Subject<void>();
  checkIn: number;
  checkOut: number;
  showMealList: boolean = false;
  constructor(
    public mealService: MealService,
    public drawerRef: DrawerRef,
    public configSvc: ConfigurationService,
    public drawerSvc: DrawerService,
    private loader: LoaderService
  ) {}
  ngOnInit() {
    this.mealService.startEndTime.pipe(takeUntil(this.endObs)).subscribe(res => {
      this.checkIn = res.startShift;
      this.checkOut = res.endShift;
      this.checkIn != -1 && this.checkOut != -1 ? (this.showMealList = true) : (this.showMealList = false);
      if (this.showMealList) {
        this.getMealBookingDetails(this.checkIn, this.checkOut, res.floorId);
      }
    });
  }

  getMealBookingDetails(start, end, floorId?: string) {
    this.loader.show();
    this.mealService.guidChange.pipe(takeUntil(this.endObs)).subscribe(guid => {
      this.mealService.getMealData(guid, start, end, floorId).subscribe(response => {
        this.loader.hide();
        this.mealData = response;
        this.mealData.forEach(element => {
          element.mealData = element.meals;
        });
        this.mealData.forEach(element => {
          element.mealData.forEach(ele => {
            for (let [key, value] of Object.entries(ele.mealOption)) {
              if (value === "None") {
                delete ele.mealOption[key];
              }
            }
          });
        });
        this.mealService.mealDataSetter(this.mealData);
        if (!this.configSvc.isMobile) this.openPremise(this.mealData?.[0]);
        this.mealService.bookingRes.pipe(takeUntil(this.endObs)).subscribe(res => {
          if (res && res.length > 0) {
            const pId = this.mealData.find(premiseId => premiseId.premiseId === res?.[0]?.premiseId);
            this.openPremise(pId);
          }
        });
      });
    });
  }

  ngOnDestroy(): void {
    this.endObs.next();
    this.endObs.complete();
  }

  openPremise(item: NsEmpWebExpData.IMeal) {
    this.show = !this.configSvc.isMobile;
    if (item) this.selectedItem = item;
    else this.selectedItem = this.mealData[0];
    if (this.configSvc.isMobile) {
      const mealRef = this.drawerSvc.show(MealOptionComponent, this.selectedItem, null);
      mealRef.afterClosed.subscribe(res => {
        if (res === "DONE") {
          this.drawerRef.close();
        }
      });
    }
    this.mealService.selectedItemResponse(this.selectedItem);
  }
}
